export const OK = 1
export const EDITED = 2
export const ERROR = 3
export const UPLOADED_TO_TIME_SHEET_ENTRIES = 4
